export enum WorkplaceRulesStaleTimeEnum {
  GetWorkplaceRules = 60000,
}
